<template>
  <div>
    <div class="mb-8 font-semibold text-white">
      <p>{{ motivation }}<span class="ml-1 text-blue-400 cursor-pointer">
              <font-awesome-icon icon="question-circle"
                                 @click="() => this.showExplanation = true"></font-awesome-icon>
            </span></p>
    </div>

    <OneButtonModal v-if="showExplanation"
                    :okColor="'green'"
                    @closeDialog="() => this.showExplanation = false"
                    @buttonClicked="() => this.showExplanation = false">
      <div slot="title">Успех и карточки</div>
      <div slot="content" class="text-white">
        <h2 class="text-xl font-bold">Зачем мне это учить?</h2>
        <p class="mt-2">Ты учишь биологию и химию, чтобы поступить в хороший университет.
          В чем ценность «хорошего универа»? Она не в том, чтобы дать диплом и профессию: больше половины людей работают не по своей специальности.</p>
        <p class="mt-2">Ценность любого универа — это сокурсники и преподаватели. Чем выше проходной балл — тем умнее
          и целеустремленнее будут люди вокруг тебя. Все 4−6 лет обучения вы будете общаться практически каждый день — это общение определит твой взгляд на мир.</p>
        <p class="mt-2">А еще у крутых универов есть доступ к более крутым преподавателям, стажировкам и оборудованию — это попросту интересно и будет полезным для работы после завершения учебы.</p>
        <h2 class="mt-8 text-xl font-bold">Среда определяет будущее</h2>
        <p class="mt-1">Правильное окружение мотивирует на постоянное движение вперед + дает возможности
          реализовать себя, как только появятся намерение + создает связи с толковыми студентами и преподавателями.</p>
        <h2 class="mt-8 text-xl font-bold">Усилия сегодня — среда завтра</h2>
        <p class="mt-1">Чем выше окажутся твои баллы на экзаменах — тем к лучшим окружениям ты получишь доступ.
          Ты точно сможешь набирать 90+ по биологии и химии, если будешь полностью выполнять ДЗ и решать карточки так,
          как подсказывает приложение. Проверено и доказано 😉</p>
        <p v-if="cardsLeft > 0"
           class="mt-6 mb-2">Сегодня осталось решить еще {{ formatFcCount(cardsLeft, 'acc') }}... 🧗</p>
        <p v-else class="mt-6 mb-2">Норма карточек на сегодня решена — отличная работа! 🥇</p>
      </div>
      <div slot="button">Понятно :)</div>
    </OneButtonModal>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import OneButtonModal from '@/components/OneButtonModal';
import { formatFcCount } from '@/assets/functions';

export default {
  components: { OneButtonModal },
  data () {
    return {
      messages: [
        'Чтобы через 5 лет выбирать работу (а не соглашаться на то, что есть)',
        'Чтобы через 7 лет купить свою машину',
        'Чтобы через 5 лет работать в интересной лаборатории с новым оборудованием',
        'Чтобы через 2 года бесплатно ездить в другие города на олимпиады и конкурсы',
        'Чтобы через 2 года учиться с умными ребятами, которые любят жизнь,',
        'Чтобы через 5 лет жить в гармонии, расходуя время только на то, что интересно,',
        'Чтобы через 8 лет совершить научное открытие',
        'Чтобы через 5 лет иметь возможность давать полезные советы другим',
        'Чтобы через 2 года находиться в компании однокурсников, которым интересен мир вокруг,',
        'Чтобы через 10 лет претворять свои идеи в жизнь силой команды из десятков умных людей',
        'Чтобы через 15 лет купить комфортный дом или квартиру',
        'Чтобы через 4 года перестать брать деньги у родителей и начать жить на свои',
        'Чтобы через 5 лет заниматься делом, которое будет приносить удовольствие и доход,',
        'Чтобы через 4 года оказаться на стажировке в Японии',
        'Чтобы через 5 лет выступать на конференции в Лондоне',
        'Чтобы через 15 лет быть самым крутым одноклассником на встрече одноклассников',
        'Чтобы через 10 лет ясно видеть свое призвание и смысл действий каждого дня',
        'Чтобы через 20 лет обеспечивать своим родителям достойную жизнь на пенсии',
        'Чтобы через 10 лет иметь высокие доход при свободном графике',
        'Чтобы через 10 лет получать впечатления от красоты реального мира, а не их замену фильмами, мемами и играми,',
      ],
      showExplanation: false,
    };
  },
  computed: {
    ...mapState({
      cardsDue: state => state.stats.due,
      cardsDone: state => state.stats.done,
    }),
    cardsLeft () { return Math.max(0, Math.min(60, this.cardsDue) - this.cardsDone); },
    motivation () {
      if (this.cardsLeft === 0 && this.cardsDone === 0)
        return 'Карточек к решению пока нет.';
      if (this.cardsLeft === 0)
        return `За сегодня ${this.cardsDone % 10 === 1 ? 'решена' : 'решено'} уже ${this.formatFcCount(this.cardsDone)} — отличная работа!`;
      const start = this.messages[Math.floor(this.messages.length * Math.random())];
      const end = ` — сегодня надо решить еще ${this.formatFcCount(this.cardsLeft, 'acc')}.`;
      return start + end;
    },
  },
  methods: {
    formatFcCount: formatFcCount,
  },
};
</script>
